import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faColumns, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ColumnVisibilityToggle from 'components/common/ColumnVisibilityToggle';
import { STYLES } from './types';

interface ColumnOption {
  id: string;
  label: string;
  visible: boolean;
}

interface ColumnVisibilityDropdownProps {
  options: ColumnOption[];
  onToggle: (id: string, visible: boolean) => void;
}

/**
 * Dropdown for toggling the visibility of table columns
 */
const ColumnVisibilityDropdown: React.FC<ColumnVisibilityDropdownProps> = ({ 
  options, 
  onToggle 
}) => {
  const { t } = useTranslation();
  
  return (
  <Dropdown>
    <Dropdown.Toggle
      variant="outline-warning"
      className="px-3 flex-shrink-0 dropdown-caret-none"
      style={STYLES.dropdown.button}
      aria-label={t('transactions.customizeTableAriaLabel', 'Customize table columns')}
    >
      <FontAwesomeIcon icon={faColumns} className="me-2" />
      {t('transactions.customizeTable', 'Customize Table')}
      <FontAwesomeIcon
        icon={faAngleDown}
        className="ms-2"
        transform="down-2"
      />
    </Dropdown.Toggle>
    <Dropdown.Menu
      style={STYLES.dropdown.menu}
      className="dropdown-menu-dark" // Added for dark mode compatibility
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <div className="mb-2 pb-2 border-bottom">
        <span className="fw-bold">{t('transactions.toggleColumns', 'Toggle Columns')}</span>
      </div>
      {options.map((column) => (
        <ColumnVisibilityToggle
          key={column.id}
          id={column.id}
          label={column.label}
          checked={column.visible}
          onChange={(checked) => onToggle(column.id, checked)}
        />
      ))}
    </Dropdown.Menu>
  </Dropdown>
  );
}

export default React.memo(ColumnVisibilityDropdown);
